export const PLATFORM_FLAG = (
	typeof window !== "undefined" ? "BROWSER" :
	typeof process !== "undefined" && !!(process.versions?.node) ? "NODE" :
	"UNKNOWN"
);



const raise = (message: string) => {
	throw new Error(message);
};

export const ENV = (
	PLATFORM_FLAG === "BROWSER" ?
		globalThis.location.hostname.startsWith("app.bracket") ? "PRODUCTION" :
		globalThis.location.hostname.startsWith("canary.bracket") ? "PRODUCTION" :
		globalThis.location.hostname.startsWith("staging.bracket") ? "STAGING" :
		"DEVELOPMENT" :
	PLATFORM_FLAG === "NODE" ?
		"DEVELOPMENT" :
		raise("UNKNOWN PLATFORM FLAG for graphql")
);
